export default __webpack_public_path__ + "static/EBGaramond-InitialsF1-99c8fe6f5a0713fbc87a858c571336a3.woff2";